import { modalService } from "@/services/modalService";

function openWinPop(url, width, height) {
    const left = (screen.width - width) / 2 - 1;
    const top = (screen.height - height) / 2 - 1;
    window.open(
        url,
        "",
        `scrollbars=1, width=+${width}, height=${height}, left=${left}, top=${top}, scrollbars=yes, resizable=yes`
    );
}

function handleError(error) {
    modalService.alert().showError(error);
}

export { openWinPop, handleError }